{
  "EMOJI": {
    "PLACEHOLDER": "Cerca emoji",
    "NOT_FOUND": "Nessuna emoji corrisponde alla tua ricerca",
    "REMOVE": "Rimuovi"
  }
}
